<template>
<div class="mReportList">
    <div class="title_box">
        <div class="title_text_box">
            <label></label>
            <span>热门推荐</span>
        </div>
        <div @click="findIndexReportByHot()" class="refresh_box">
            <img :src="require('@/common/images/report/mobile/icon_refresh.png')" alt="">
            <span>换一批</span>
        </div>
    </div>
    <div class="report_list_warp">
        <div  @click="toReportDetails(item)" class="report_list_item" v-for="(item, index) in reportListData" :key="index">
            <div v-if="index < 2" class="report_big_box">
                <div class="img_box">
                    <img v-lazy="item.coverurl" :alt="item.subject">
                </div>
                <div class="van-multi-ellipsis--l2">{{item.subject}}</div>
            </div>
            <div v-else class="report_little_box">
                <div class="img_box">
                    <img v-lazy="item.coverurl" :alt="item.subject">
                </div>
                <div class="van-ellipsis">{{item.subject}}</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {getIndexReportByHot} from 'api/reportApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'mHotReportList',
    data() {
        return {
            reportListData: []
        }
    },
    mounted() {
        setTimeout(()=>{
            this.findIndexReportByHot()
        }, 0)
    },
    methods: {
        // 点击报告
        toReportDetails(val) {
            // console.log(val)
            this.setRefresh(true)
            this.$router.push({name: 'MReportDetails', query: {'reportid': val.innerid}})
        },
        findIndexReportByHot() {
            this.setLoading(true)
            getIndexReportByHot({
                data: {},
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.reportListData = data.data.hotreportlist
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.mReportList {}
</style>